import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { ComponentBehaviour } from "src/app/models/component-behaviour";

@Injectable()
export class ComponentBehaviourService {

    private baseUrl: string = environment.BASE_URL;
    constructor(private http: HttpClient) {
    }

    public getBehaviour(behaviourId: string): Observable<ComponentBehaviour> {
        return this.http.get(`${this.baseUrl}behaviour/${behaviourId}`) as Observable<ComponentBehaviour>;
    }

  public getBehaviourByServiceIdAndComponentKey(serviceId: string, componentKey: string): Observable<ComponentBehaviour> {
    return this.http.get(`${this.baseUrl}service/${serviceId}/behaviour/${componentKey}`) as Observable<ComponentBehaviour>;
  }

    public getBehaviourCounter(behaviourId: string): Observable<number> {
        return this.http.get(this.baseUrl + "/behaviour/" + behaviourId + "/counter") as Observable<number>;
    }

    public getBehaviours(serviceId: string): Observable<ComponentBehaviour[]> {
        return this.http.get(`${this.baseUrl}service/${serviceId}/behaviour`) as Observable<ComponentBehaviour[]>;
    }

    public saveBehaviour(serviceId: string, behaviour: ComponentBehaviour): Observable<ComponentBehaviour> {
        const body = JSON.stringify(behaviour);
        return this.http.post(`${this.baseUrl}service/${serviceId}/behaviour`, body) as Observable<ComponentBehaviour>;
    }

    public updateBehaviour(behaviour: ComponentBehaviour): Observable<ComponentBehaviour> {
        const body = JSON.stringify(behaviour);
        return this.http.put(`${this.baseUrl}behaviour`, body) as Observable<ComponentBehaviour>;
    }

    public deleteBehaviour(behaviourId: string) {
        return this.http.delete(`${this.baseUrl}behaviour/${behaviourId}`);
    }
}
